import * as React from 'react';
import cx from 'classnames';
import getTextPosition from './position';
var DEFAULT_SIZE = 24;
export default function CircleIcon(_a) {
    var size = _a.size, text = _a.text, textPosition = _a.textPosition;
    size = size || DEFAULT_SIZE;
    return (React.createElement("div", { className: cx('zent-loading-icon-and-text', getTextPosition(textPosition)), "data-zv": '8.4.0' },
        React.createElement("div", { className: "zent-loading-icon zent-loading-icon-circle", style: { width: size, height: size }, "data-zv": '8.4.0' }),
        text && React.createElement("div", { className: "zent-loading-icon-text", "data-zv": '8.4.0' }, text)));
}
